/* Svensk katalog for locale-transaction-detail-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'transaction.annulBy': 'Annullerad av',
  "transaction.annulAudit": "Annulleringshistorik",
  "transaction.annulledAt": "Annullerad den",
  "transaction.annulReason": "Orsak",
  "transaction.annulActor": "Användar-ID",
  "transaction.reversalDate": "Motbokningens bokföringsdatum",
  "transaction.openOriginal": "Öppna ursprunglig bokning",
  "transaction.openReversal": "Öppna motbokning",
  "transaction.auditMissing": "Inte registrerat",
  "transaction.reversalMissing": "Motbokningen finns inte i den inlästa journalen.",
  "transaction.auditDebit": "Debet",
  "transaction.auditCredit": "Kredit",

  'transaction.incompleteBasis': 'Journaltäckningen är ofullständig. Den här verifikationen visas för dokumentation och diagnostik; totalerna får inte tolkas som fullständiga.',
  'route.transaction': 'Transaktion',
  'transaction.back': 'Tillbaka till alla transaktioner',
  'transaction.title': 'Transaktion',
  'transaction.posting': 'Kontering',
  'transaction.summary': 'Sammanfattning – belopp in och ut från konton',
  'transaction.account': 'Konto',
  'transaction.incoming': 'In på konto',
  'transaction.outgoing': 'Ut från konto',
  'transaction.total': 'Summa',
  'transaction.description': 'Beskrivning',
  'transaction.links': 'Kopplade poster',
  'transaction.sourceLead': 'Det här är bokföring av',
  'transaction.sourceHelp': 'Öppna källan om du ska göra ändringar i transaktionen eller en kopplad betalning.',
  'transaction.relatedPayments': 'Relaterade betalningar',
  'transaction.correctionReplacement': 'Ersättningsverifikation',
  'transaction.correctionOriginal': 'Ursprunglig verifikation',
  'transaction.correctionReason': 'Orsak till korrigering',
  'transaction.created': 'Skapad',
  'transaction.by': 'av',
  'transaction.vatCodes': 'Momskoder',
  'transaction.accountNumber': 'Kontonr',
  'transaction.name': 'Namn',
  'transaction.amount': 'Belopp',
  'transaction.documentation': 'Dokumentation',
  'transaction.generatedDocument': 'Fakturadokumentet genereras när du öppnar eller laddar ned det.',
  'transaction.noDocumentation': 'Ingen dokumentation har bifogats den här transaktionen.',
  'transaction.open': 'Öppen kontering',
  'transaction.locked': 'Låst kontering',
  'transaction.annulled': 'Annullerad',
  'transaction.fallbackType': 'Kontering',
  'transaction.notFound': 'Hittade inte transaktionen',
  'transaction.notFoundHelp': 'Transaktionen kan vara annullerad, tillhöra ett annat räkenskapsår eller inte längre vara tillgänglig.',
  'transaction.invoice': 'Faktura',
  'transaction.purchase': 'Inköp',
  'transaction.otherSale': 'Annan försäljning',
  'transaction.customs': 'Tulldeklaration',
  'transaction.openDocument': 'Visa verifikation',
  'transaction.download': 'Ladda ned',
  'transaction.upload': 'Ladda upp bilaga',
  'transaction.uploaded': 'Bilagan har laddats upp.',
  'transaction.uploadFailed': 'Det gick inte att ladda upp bilagan.',
  'transaction.documentFailed': 'Det gick inte att hämta verifikationen från backend.',
  'transaction.previewFailed': 'Det gick inte att visa verifikationen.',
  'transaction.lost': 'Verifikation förlorad',
  'transaction.lostPrompt': 'Förklaring till loggen (valfritt):',
  'transaction.lostSaved': 'Verifikationen är markerad som förlorad.',
  'transaction.lostFailed': 'Det gick inte att markera verifikationen som förlorad.',
  'transaction.annul': 'Annullera transaktion',
  'transaction.annulQuestion': 'Annullera transaktion?',
  'transaction.creditQuestion': 'Kreditera faktura?',
  'transaction.credit': 'Kreditera',
  'transaction.annulling': 'Annullerar...',
  'transaction.annulHelp': 'Transaktionen annulleras och behålls som historik, men tas inte med i rapportunderlaget.',
  'transaction.creditHelp': 'Fakturan krediteras med en kreditfaktura som skapas som utkast för kontroll innan den skickas.',
  'transaction.creditDraft': 'Kreditfakturan har skapats som utkast. Kontrollera och skicka den från fakturalistan.',
  'transaction.annulledSaved': 'Transaktionen har annullerats.',
  'transaction.annulFailed': 'Det gick inte att annullera transaktionen.',
  'transaction.privateReimbursed': 'Det privata utlägget har återbetalats.',
  'transaction.privateReimburseFailed': 'Det gick inte att återbetala det privata utlägget.',
  'transaction.reimbursePrivate': 'Återbetala privat utlägg',
  'transaction.reimbursePrivateHelp': 'Bokför återbetalningen från valt företagsbankkonto mot konto 2060 utan att bokföra kostnad eller moms på nytt.',
  'transaction.paymentDate': 'Betalningsdatum',
  'transaction.bankAccount': 'Bankkonto',
  'transaction.goTo': 'Gå till',
  'transaction.bank': 'Bank',
  'transaction.vat': 'Moms',
  'transaction.yearEnd': 'Bokslut',
});
